// extracted by mini-css-extract-plugin
export var root = "PlasmicFormButton-module--root--Ruxnc";
export var text = "PlasmicFormButton-module--text--rEtiN";
export var textsubscribed = "PlasmicFormButton-module--textsubscribed--QHM8+";